import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';

const parameters = (state) => state.postbackParameters.list;
const postback = (state) => state.postbacks.list.data[0];
const location = (state) => state.routingCompat;

export const getHeaderNames = createSelector(
    () => {
        const creatingEditingTableName = UserStore.getTranslation().postbackPage.creatingEditing.table;

        return [
            ' ',
            creatingEditingTableName.variableName,
            creatingEditingTableName.valueVariable,
            creatingEditingTableName.macros
        ];
    }
);

export const getData = createSelector(
    parameters,
    postback,
    location,
    (parameters = [], postback = {}, location = {}) => {
        const isCreate = location.pathname === '/postback/create';
        let postbackParameters = [];
        let list = [];
        let selected = [];

        if (!isCreate) {
            postbackParameters = (postback.config && postback.config.parameters && [...postback.config.parameters]) || [];
        }

        if (parameters.length) {
            parameters.map((item) => {
                let param = {
                    checked: false,
                    data: {
                        ...item
                    }
                };
                const index = postbackParameters.length ? postbackParameters.findIndex((item) => item.value === param.data.macros) : -1;

                if (index !== -1) {
                    param.checked = true;
                    param.data.name = postbackParameters[index].name;

                    selected.push({
                        name: postbackParameters[index].name,
                        value: param.data.macros
                    });
                    postbackParameters.splice(index, 1);
                }

                list.push(param);
            });
        }

        return {
            list,
            selected: selected.concat(postbackParameters),
            extra: selected.length ? [...postbackParameters] : []
        };
    }
);
